import styled from 'styled-components';

export const ButtonStyled = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;

  &:hover {
    cursor: pointer;
  }
`;
